export interface UpdateOrderListSelectionsRequest {
  id: string
  selections: {
    id: number
    reason: string
    type: string
  }[]
  revision: number
}

export function UpdateOrderListSelectionsRequestToJSON(
  value: UpdateOrderListSelectionsRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    selections:
      value.selections.length > 0
        ? value.selections.map(selection => {
            return {
              id: selection.id ? selection.id : undefined,
              reason: selection.reason !== '' ? selection.reason : undefined,
              type: selection.type !== '' ? selection.type : undefined
            }
          })
        : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
